module.exports = __webpack_public_path__ + "static/media/EnterName.43f25ac3.png";